<!-- Section Électrolyseur Cellule -->
<app-collapse
  [title]="'P00037.status.electrolyseurCellule' | translate"
  [warning]="
    getValue('elSProtectionHivernage') === 1 ||
    getValue('elSDefautCourant') === 1 ||
    getValue('elSCaracteristiqueCelluleUtilise') === 0
  "
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.protectionHivernage' | translate"
      [warning]="getValue('elSProtectionHivernage') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />

    <app-display-rubrique-status
      [title]="'P00037.status.polarite' | translate"
      [value]="getPolariteLabel(getValue('elSEtatInverseurPolarite'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00037.status.nbrPolarite' | translate"
        [value]="getValue('elSNombreInversionPolarite') + ''"
      />

      <app-display-rubrique-status
        [title]="'P00037.status.tempEau' | translate"
        [value]="
          getValue('elSDisponibiliteTemperatureEau') === 1
            ? ('P00037.status.ok' | translate)
            : ('P00037.status.indisponible' | translate)
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P00037.status.consommation' | translate"
      [value]="
        (getValue('elSConsigneMesureCellule') / 10).toFixed(1) +
        ('P00037.status.A' | translate)
      "
    />

    <app-display-rubrique-status
      [title]="'P00037.status.puissance' | translate"
      [value]="getValue('elSPuissanceActive') + ('P00037.status.W' | translate)"
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.caraccelluleutilise' | translate"
      [warning]="getValue('elSCaracteristiqueCelluleUtilise') === 0"
      [icon]="'fa-exclamation-triangle'"
      [text]="
        getCaracteristiqueCelluleLabel(
          getValue('elSCaracteristiqueCelluleUtilise')
        )
      "
    />

    <app-display-rubrique-status
      [title]="'P00037.status.resulttestcellule' | translate"
      [value]="
        getResultatTestCelluleLabel(getValue('elSResultatTestUsureCellule'))
      "
    />

    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.defautCourant' | translate"
      [warning]="getValue('elSDefautCourant') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />
  </div>
</app-collapse>

<!-- Section Désinfection -->
<app-collapse
  [title]="'P00037.status.desinfection' | translate"
  [warning]="
    getValue('elSSecuriteDesinfection') === 1 ||
    getValue('elSMesureDebit') === 0 ||
    getValue('elSNiveauSelBas') === 1 ||
    getValue('elSProtectionPresenceGaz') === 1
  "
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.detectionDebit' | translate"
      [warning]="getValue('elSMesureDebit') === 0"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00037.status.oui' | translate"
    />

    <app-display-rubrique-status
      [title]="'P00037.status.tempsrestantboost' | translate"
      [value]="
        getValue('elSTempsRestantBoost') === 0
          ? '...'
          : getValue('elSTempsRestantBoost') + 'h'
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00037.status.disponibilitedebit' | translate"
        [value]="
          getValue('elSDisponibiliteDebit') === 0
            ? ('P00037.status.indisponible' | translate)
            : ('P00037.status.ok' | translate)
        "
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.secuDesinfection' | translate"
      [warning]="getValue('elSSecuriteDesinfection') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00037.status.ok' | translate"
    />

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00037.status.tauxselbassin' | translate"
      [warning]="getValue('elSNiveauSelBas') === 1"
      [notWarning]="'-'"
      [ctaText]="'P00037.status.tauxselbassin.value' | translate"
      (onPress)="resetNiveauSel()"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00037.status.mesureRX' | translate"
        [value]="
          getValue('elSDisponibiliteSondeRX') === 0
            ? ('P00037.status.indisponible' | translate)
            : ('P00037.status.ok' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00037.status.abaissementVolet' | translate"
        [value]="
          getValue('elSAbaissementVolet') === 0
            ? '-'
            : ('P00037.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00037.status.disponibilitevolet' | translate"
        [value]="
          getValue('elSDisponibiliteVolet') === 0
            ? ('P00037.status.indisponible' | translate)
            : ('P00037.status.ok' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00037.status.prioriteElectrolyse' | translate"
        [value]="
          getValue('elSMiseEnRouteFiltrationPriorite') === 0
            ? '-'
            : ('P00037.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00037.status.prioriteElectrolyseBoost' | translate"
        [value]="
          getValue('elSMiseEnRouteFiltrationPrioriteBoost') === 0
            ? '-'
            : ('P00037.status.enCours' | translate)
        "
      />

      <app-display-rubrique-status
        [title]="'P00037.status.autoFiltration' | translate"
        [value]="
          getValue('elSMiseEnRouteFiltrationAutoMaintien') === 0
            ? '-'
            : ('P00037.status.enCours' | translate)
        "
      />
    }

    <app-display-rubrique-status-with-warning-and-cta
      [title]="'P00037.status.protectionpresenceGaz' | translate"
      [warning]="getValue('elSProtectionPresenceGaz') === 1"
      [notWarning]="'-'"
      [ctaText]="'P00037.status.protectionpresenceGaz.value' | translate"
      (onPress)="resetProtectionPresenceGaz()"
    />
  </div>
</app-collapse>

<!-- Section Produit -->
<app-collapse
  [title]="'P00037.status.produit' | translate"
  [warning]="presenceProduit === 2 || getValue('elSProtectionThermique') === 1"
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.connexionCoffret' | translate"
      [warning]="presenceProduit === 2"
      [icon]="'fa-exclamation-triangle'"
      [text]="'P00037.status.ok' | translate"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00037.status.fonctionnementelectrolyseur' | translate"
        [value]="getEtatProductionLabel(getValue('elSEtatProduction'))"
      />
    }

    <app-display-rubrique-status-with-warning
      [title]="'P00037.status.protectionthermique' | translate"
      [warning]="getValue('elSProtectionThermique') === 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="'-'"
    />

    <app-display-rubrique-status
      [title]="'P00037.status.limitepuissance' | translate"
      [value]="
        getValue('elSEtatLimiteurPuissance') === 0
          ? '-'
          : ('P00037.status.enCours' | translate)
      "
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P00037.status.puissanceTotale' | translate"
        [value]="getValue('elSCompteurPuissanceActiveTotale') + ' Wh'"
      />

      <app-display-rubrique-status
        [title]="'P00037.status.compteurAmpere' | translate"
        [value]="getValue('elSTransferChargeCellule') + ' Ah'"
      />

      <app-display-rubrique-status-on-off
        [title]="'P00037.status.bouton' | translate"
        [value]="getValue('elSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="'P00037.status.cptBouton' | translate"
        [value]="getValue('elSCompteurBouton') + ''"
      />
    }
  </div>
</app-collapse>
